module.exports = __webpack_public_path__ + "static/media/david.12222871.jpg";